module.exports = __webpack_public_path__ + "img/card-sample02.05419d15.png";